import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  styleUrls: ['../../global-styles.less', './tellent-org-deleted.component.less'],
  templateUrl: './tellent-org-deleted.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class TellentOrgDeletedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TellentOrgDeletedTemplateData>;
}

export type TellentOrgDeletedTemplateData = {
  header: string;
  subheader_html: string;
  body: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const TellentOrgDeletedTemplateMocks: TellentOrgDeletedTemplateData[] = [
  {
    header: 'Company account deletion confirmation',
    subheader_html: `The <b>%{companyName}</b> company account has been permanently deleted, and all associated data has been removed.`,
    body: `You received this email because you’re a member of the %{companyName} company account.`,
    footer: {
      text: 'Need help?',
      href: 'https://auth.tellent.com/?intercom_open=true',
      label: 'Contact us',
      target: '_blank',
    },
  },
];
